import { render, staticRenderFns } from "./NetlifyIdentityAdmin.vue?vue&type=template&id=cd645f80&"
import script from "./NetlifyIdentityAdmin.vue?vue&type=script&lang=js&"
export * from "./NetlifyIdentityAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports